<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_ANTICIPO_CESANTIAS"/>
          ANTICIPO DE CESANTIAS
        </span>
        <g-master name="empcocespar"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  modalWidth="80%"
                  :useMultipart="true"
                  ref="master"
                  @action="masterAction"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
      <span slot="estadoRenderer" slot-scope="{text}">
        <div v-if="text ==='CERRADO'">
          <a-tag color="red">{{text}}</a-tag>
        </div>
        <div v-if="text ==='LIQUIDADO'">
          <a-tag color="blue">{{text}}</a-tag>
        </div>
      </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados_en_reqliquidacion"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de pago')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['payment_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Tipo censantías')"
                            :formItemConfig="fiOptions"
                            :decorator="['cespar_type', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'EST' }]"
                            :params="cesantias">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor a solicitar')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['cespar_ammount', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-show="false" v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Estado')">
                  <a-input
                    style="width: 100%"
                    :disabled="true"
                    v-decorator="['estado_quemado', {rules: [{ required: false }], initialValue: 'LIQUIDADO' }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="third"
                            :label="$t('Tercero')"
                            :formItemConfig="fiOptions"
                            :params="{filter_third_cespar: true}"
                            :decorator="['id_h_tercero', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup v-bind="fiOptions"
                          endpoint="coc"
                          :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_coc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: false},
                           ], initialValue: yearToday }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ], initialValue: monthToday  }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Período')"
                            :formItemConfig="fiOptions"
                            :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="period_request">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Radicación')">
                  <a-input
                    style="width: 100%"
                    v-decorator="['radicacion', {rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Resolución')">
                  <a-input
                    style="width: 100%"
                    v-decorator="['resolution', {rules: [{ required: false }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha resolución')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['resolution_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Observaciones')">
                  <a-textarea autoSize
                              v-decorator="['cespar_comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
                  <a-upload
                    name="profile_file"
                    :before-upload="beforeUpload"
                    :fileList="master.uploads.profileFile"
                    :remove="() => { master.uploads.profileFile = [] }">
                    <a-button style="width: 100%">Seleccionar archivo</a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        loadingBtns: {},
        nombreEntidad: {},
        yearToday: parseInt(moment().format('YYYY')),
        monthToday: String(moment().format('MM')),
        years: [],
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        nombreEntidadSeleccionada: '',
        cesantias: {
          h_lookup_type: 'TIPO_CENSANTIAS',
          use_code: true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'emp_co_cespar',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_completo', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Fecha de pago', dataIndex: 'fecha_pago', sorter: true},
              {title: 'Tipo de cesantía', dataIndex: 'tipo_censantia', sorter: true},
              {title: 'Valor a solicitar', dataIndex: 'cespar_ammount', sorter: true, align: 'right'},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Periodo', dataIndex: 'period', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: () => !this.$userIsInrol('Query')
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: () => !this.$userIsInrol('Query')
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'payment_date'},
            {name: 'cespar_type'},
            {name: 'estado_quemado'},
            {name: 'period'},
            {name: 'month'},
            {name: 'year'},
            {name: 'cespar_comments'},
            {name: 'resolution'},
            {name: 'resolution_date'},
            {name: 'cespar_ammount'},
            {name: 'id_coc'},
            {name: 'radicacion'}
          ],
          uploads: {
            profileFile: []
          },
          estado_cesantia: 'LIQ',
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return {...data, cespar_status: this.estado_cesantia}
          }
        },
        paramsT: {},
        endpointExcel: 'emp_co_cespar_/downloadExcel',
        fileNameExcel: 'AnticipoDeCesantias'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 4); i++) {
          this.years.push(i)
        }
      },
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break

          case 'masterCreate':
            this.estado_cesantia = 'LIQ'
            break
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            if (action.record.cespar_status === 'CER') {
              this.estado_cesantia = 'CER'
              this.$refs.master.modal.form.setFieldsValue({
                estado_quemado: 'CERRADO'
              })
            } else {
              this.estado_cesantia = 'LIQ'
              this.$refs.master.modal.form.setFieldsValue({
                estado_quemado: 'LIQUIDADO'
              })
            }
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('emp_co_cespar/download', {
          id: record.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/EmpCoCespar.vue